module.exports = __webpack_public_path__ + "img/GB.a4347f1a.svg";